export const QUESTION = {
    jap: {
        title1: "本日は東屋にご滞在いただきありがとうございます。",
        title2: "東屋ではこれからベトナム1番のサービスと快適な空間を提供したいと思っております。",
        title3: "ぜひお客様のご意見、ご感想をお聞かせください。",
        questionroomNumber: {
            title: "お部屋の番号を教えていただきませんか?",
            answer: "",
        },
        questionbranchID: {
            title: "滞在している支店",
            answer: "",
        },
        question1: {
            title: "滞在期間をお聞かせください。",
            answer: [
                "1泊",
                "2~6泊",
                "1~4週間",
                "1ヶ月以上",
            ]
        },
        question2: {
            title: "お客様の年齢をお聞かせください。",
            answer: [
                "内緒", 
                "20歳以下",
                "20代",
                "30代",
                "40代",
                "50代以上",
            ]
        },
        question3: {
            title: "東屋ベトナムへの来店頻度をお聞かせ下さい。",
            answer: [
                "初めて",
                "2回目",
                "3回目",
                "それ以上",
            ]
        },
        question4: {
            title: "当店をお知りになったきっかけを教えてください.",
            answer : [
                "会社手配",
                "ご紹介",
                "東屋ウェブ",
                "アゴダなどのホテル予約サイト", //"店頭の看板",
                "グーグル",
                "SNS",
                "ポステ",
                "雑誌",
                "それ以外",
            ]
        },
        question5: {
            title: "各サービスの満足度を採点してください.", //当店を紡刻りになったきっがけ形を散えでく<だきい.
            title2: "* サービスを利用されていない項目は未記人でお願いします",
            answer: [
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
            ],
        },
        question6: {
            title: "ホテルをお選びになる点で、特に重視されることをお聞かせください。(複数回答可)",
            answer : [
                "価格",
                "立地",
                "露天風呂",
                "清潔感",
                "朝食の充実",
                "備品、アメニティー",
                "スタッフの対応",
                "日本語テレビ",
                "ネット環境",
                "マッサージ併設",
                "日本語対応",
                "日本食レストラン併設",
                "その他",
            ]
        },
        question7: {
            title: "次のご利用について。",
            answer: [
                "また来たい",
                "分からない",
                "来ない",
            ]
        },
        question8: {
            title: "その他、ご意見、改善点があればお願いします。",
            answer: ""
        }
    },
    eng : {
        title1: "Thank you for your staying at our Azumaya Hotel. ",
        title2: "We hope to listen your opinions to provide you the best service.",
        title3: "",
        questionroomNumber: {
            title: "Your room number?",
            answer: "",
        },
        questionbranchID: {
            title: "The branch Azumaya you are staying at?",
            answer: "",
        },
        question1: {
            title: "Duration of your staying.",
            answer: [
                "1 night",
                "2~6 nights",
                "1~4 Weeks",
                "More than 1 month",
            ]
        },
        question2: {
            title: "Your age",
            answer: [
                "Secret",
                "Under 20",
                "20s",
                "30s",
                "40s",
                "Over 50s",
            ]
        },
        question3: {
            title: "How many times have you stayed at Azumaya Hotel.",
            answer: [
                "First time",
                "Second time",
                "Third time",
                "More than 3 times",
            ]
        },
        question4: {
            title: "How did you know AZ.",
            // answer : [
            //     "AZ Phnom Penh ",
            //     "Advertisement", //  "LIV",
            //     "Magazine",  //VETTER
            //     "POSTE",
            //     "AZ Web",
            //     "Company",
            //     "Introduction",
            //     "AZ Signboard",
            //     "Other",
            // ],
            answer : [
                "Company",
                "Introduction",
                "AZ Web",
                "Booking sites as Agoda",//"AZ Signboard",
                "Google",
                "SNS",
                "POSTE",
                "Magazine",
                "Other",
            ]
        },
        question5: {
            title: "Please evaluate our services.", //当店を紡刻りになったきっがけ形を散えでく<だきい.
            title2: "*lf you don't use some services, please don't evaluate",
            answer: [
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
            ],
        },
        question6: {
            title: "Which are your important things to choose a hotel for staying (multiple choices)",
            answer : [
                "Price",                                                     
                "Location",                                   
                "Open air hot tub",
                "Rom cleanliness",                                 
                "Breakfast",                                   
                "Facility/Amenity",
                "Staff's attitude",                                   
                "Japanese TV",                              
                "Internet",
                "Massage",                                            
                "Hospitality JP",           
                "Japanese Restaurant",
                "Other",
            ]
        },
        question7: {
            title: "Will you come to Azumaya again?",
            answer: [
                "yes",
                "Do not know",
                "No",
            ]
        },
        question8: {
            title: "Do you have any suggestions?",
            answer: ""
        }
    },
    vie: {
        title1: "Cảm ơn quý khách lựa chọn Azumaya.",
        title2: "Azumaya mong muốn cung cấp dịch vụ tốt nhất và không gian thoải mái tại Việt Nam.",
        title3: "Hãy cho chúng tôi biết ý kiến ​​và suy nghĩ của quý khách để cải thiện hơn về dịch vụ.",
        questionroomNumber: {
            title: "Xin cung cấp số phòng của quý khách được không?",
            answer: "",
        },
        questionbranchID: {
            title: "Chi nhánh quý khách đang lưu trú ?",
            answer: "",
        },
        question1: {
            title: "Vui lòng cho chúng tôi biết thời gian lưu trú của quý khách.",
            answer: [
                "1 đêm",
                "2-6 đêm",
                "1-4 tuần",
                "Hơn 1 tháng",
            ]
        },
        question2: {
            title: "Xin vui lòng cho chúng tôi biết tuổi của quý khách.",
            answer: [
                "Bí mật", 
                "Dưới 2 tuổi",
                "20 tuổi",
                "30 tuổi",
                "40 tuổi",
                "Trên 50 tuổi",
            ]
        },
        question3: {
            title: "Quý khách ghé thăm Azumaya Việt Nam thường xuyên như thế nào?",
            answer: [
                "Lần đầu tiên",
                "Lần thứ 2",
                "Lần thứ 3",
                "Nhiều hơn",
            ]
        },
        question4: {
            title: "Vui lòng cho chúng tôi biết quý khách biết đến Azumaya bằng cách nào.",
            answer : [
                "Công ty",
                "Giới thiệu",
                "Website Azumaya",
                "Web đặt phòng như Agoda", 
                "Google",
                "SNS",
                "POSTER",
                "Tạp chí",
                "Khác",
            ]
        },
        question5: {
            title: "Vui lòng đánh giá mức độ hài lòng của quý khách với từng dịch vụ.", //当店を紡刻りになったきっがけ形を散えでく<だきい.
            title2: "* Vui lòng để trống bất kỳ mục nào mà quý khách không sử dụng dịch vụ.す",
            answer: [
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
                {
                    answer: 0,
                    subAnswer : 0,
                    nameSubAnswer: ""
                },
            ],
        },
        question6: {
            title: "Xin vui lòng cho biết những yếu tố quan trọng nhất khi chọn khách sạn. (Có thể chọn nhiều đáp án)",
            answer : [
                "Giá cả",
                "Vị trí",
                "Bồn tắm lộ thiên",
                "Sự sạch sẽ",
                "Bữa sáng đầy đủ",
                "Thiết bị, tiện nghi",
                "Thái độ nhân viên",
                "Truyền hình tiếng Nhật",
                "Môi trường mạng",
                "Dịch vụ massage",
                "Hỗ trợ tiếng Nhật",
                "Nhà hàng Nhật Bản",
                "Khác"
            ]
        },
        question7: {
            title: "Về lần sử dụng tiếp theo.",
            answer: [
                "Muốn quay lại",
                "Chưa biết",
                "Không quay lại"
            ]
        },
        question8: {
            "title": "Nếu bạn có ý kiến hoặc đề xuất cải thiện khác, vui lòng cho chúng tôi biết.",
            "answer": ""
        }
    },
    kor: {
        "title1": "아즈마야 호텔에 머물러 주셔서 감사합니다.",
        "title2": "최상의 서비스를 제공하기 위해 고객님의 의견을 듣고 싶습니다.",
        "title3": "",
        "questionroomNumber": {
            "title": "객실 번호는?",
            "answer": ""
        },
        "questionbranchID": {
            "title": "현재 머물고 있는 아즈마야 호텔 지점은?",
            "answer": ""
        },
        "question1": {
            "title": "숙박 기간",
            "answer": [
                "1박",
                "2~6박",
                "1~4주",
                "1개월 이상"
            ]
        },
        "question2": {
            "title": "연령대",
            "answer": [
                "비밀",
                "20세 미만",
                "20대",
                "30대",
                "40대",
                "50대 이상"
            ]
        },
        "question3": {
            "title": "아즈마야 호텔에 몇 번 숙박하셨나요?",
            "answer": [
                "첫 번째 방문",
                "두 번째 방문",
                "세 번째 방문",
                "3회 이상 방문"
            ]
        },
        "question4": {
            "title": "아즈마야 호텔을 어떻게 알게 되었나요?",
            "answer": [
                "회사",
                "소개",
                "AZ 웹사이트",
                "Agoda와 같은 예약 사이트",
                "구글",
                "SNS",
                "POSTE",
                "잡지",
                "기타"
            ]
        },
        "question5": {
            "title": "서비스를 평가해주세요.",
            "title2": "*일부 서비스를 이용하지 않으셨다면 평가하지 않으셔도 됩니다.",
            "answer": [
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                }
            ]
        },
        "question6": {
            "title": "호텔을 선택할 때 중요하게 생각하는 요소는 무엇인가요? (복수 선택 가능)",
            "answer": [
                "가격",
                "위치",
                "노천탕",
                "객실 청결도",
                "조식",
                "시설/편의용품",
                "직원 태도",
                "일본어 TV",
                "인터넷 환경",
                "마사지",
                "일본어 서비스 제공",
                "일식 레스토랑",
                "기타"
            ]
        },
        "question7": {
            "title": "아즈마야 호텔을 다시 방문하시겠습니까?",
            "answer": [
                "예",
                "모르겠다",
                "아니요"
            ]
        },
        "question8": {
            "title": "개선할 점이나 제안 사항이 있나요?",
            "answer": ""
        }
    },
    chn: {
        "title1": "感谢您选择在有马屋酒店住宿。",
        "title2": "有马屋致力于在越南提供最优质的服务和舒适的空间。",
        "title3": "",
        "questionroomNumber": {
            "title": "请提供您的房间号？",
            "answer": ""
        },
        "questionbranchID": {
            "title": "您正在入住的有马屋酒店分店？",
            "answer": ""
        },
        "question1": {
            "title": "您的住宿时长",
            "answer": [
                "1晚",
                "2~6晚",
                "1~4周",
                "1个月以上"
            ]
        },
        "question2": {
            "title": "您的年龄",
            "answer": [
                "保密",
                "20岁以下",
                "20多岁",
                "30多岁",
                "40多岁",
                "50岁以上"
            ]
        },
        "question3": {
            "title": "您在有马屋酒店住过几次？",
            "answer": [
                "第一次",
                "第二次",
                "第三次",
                "3次以上"
            ]
        },
        "question4": {
            "title": "您是如何了解有马屋酒店的？",
            "answer": [
                "公司安排",
                "朋友介绍",
                "AZ网站",
                "Agoda等预订网站",
                "谷歌搜索",
                "社交媒体",
                "宣传单",
                "杂志",
                "其他"
            ]
        },
        "question5": {
            "title": "请评价我们的服务。",
            "title2": "*如果您未使用某项服务，请勿进行评价。",
            "answer": [
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                },
                {
                    "answer": 0,
                    "subAnswer": 0,
                    "nameSubAnswer": ""
                }
            ]
        },
        "question6": {
            "title": "选择酒店时，您最看重哪些因素？（可多选）",
            "answer": [
                "价格",
                "位置",
                "露天温泉",
                "房间清洁度",
                "早餐",
                "设施/便利设施",
                "员工态度",
                "日语电视",
                "互联网环境",
                "按摩服务",
                "日语服务",
                "日式餐厅",
                "其他"
            ]
        },
        "question7": {
            "title": "您会再次访问有马屋酒店吗？",
            "answer": [
                "是的",
                "不确定",
                "不会"
            ]
        },
        "question8": {
            "title": "如果您有任何建议或改进意见，请告诉我们。",
            "answer": ""
        }
    }
}

export const QUESTION_AZPP = {
    jap: {
        title2: "東屋ではこれからカンボジア1番のサービスと快適な空間を提供したいと思っております。",
        question3: {
            title: "東屋プノンペンへの来店頻度をお聞かせ下さい。",
            answer: [
                "初めて",
                "2回目",
                "3回目",
                "それ以上",
            ]
        },
        question4: {
            title: "当店をお知りになったきっかけを教えてください.",
            answer : [
                // "東屋ベトナム",
                // "店頭の看板",
                // "広告", //"LIV"
                // "雑誌", // ベッター
                // "ポステ",
                // "東屋ウェブ",
                // "会社手配",
                // "こ紹介",
                // "それ以外", //それ以上
                "会社手配",
                "ご紹介",
                "東屋ウェブ",
                "店頭の看板",
                "グーグル",
                "SNS",
                "ポステ",
                "雑誌",
                "それ以外",
            ]
    }

    },
    eng: {
        title2: "We hope to listen your opinions to provide you the best service.",
        question3: {
            title: "How many times have you stayed at Azumaya Hotel.",
            answer: [
                "First time",
                "Second time",
                "Third time",
                "More than 3 times",
            ]
        },
        question4: {
            title: "How did you know AZ.",
            answer : [
                // "AZ Viet Nam",
                // "Advertisement", //  "LIV",
                // "Magazine",  //VETTER
                // "POSTE",
                // "AZ Web",
                // "Company",
                // "Introduction",
                // "AZ Signboard",
                // "Other",
                "Company",
                "Introduction",
                "AZ Web",
                "Agoda,Expedia,Booking.com...",//"AZ Signboard",
                "Google",
                "SNS",
                "POSTE",
                "Magazine",
                "Other",
            ]
        },
    },
    chn: {
        title2: "有马屋致力于在柬埔寨提供最优质的服务和舒适的空间。",
        question3: {
            title: "您在有马屋金边酒店住过几次？",
            answer: [
                "第一次",
                "第二次",
                "第三次",
                "3次以上"
            ]
        },
        question4: {
            title: "您是如何了解有马屋的？",
            answer: [
                "公司安排",
                "朋友介绍",
                "有马屋网站",
                "招牌",
                "谷歌搜索",
                "社交媒体",
                "宣传单",
                "杂志",
                "其他"
            ]
        }
    }
}
export const QUESTION5_SUB_ANSWER = {
    jap: {
        5: [
            "インターネット",
            "家具",
            "テレビ",
            "バスルーム",
            "エアコン",
            "マットレス",
            "その他",
        ],
        6: [
            "部屋",
            "におい",
            "その他",
            "バスルーム",
            "リネン",
        ],
        8: [
            "使用しない",
            "清潔さ",
            "風呂の温度",
            "顧客が多い",
            "その他",
        ],
        9: [
           "使用しない",
           "マツサージの質",
           "ルスタッフの態度",
           "屋内の環境",
           "その他",
        ],
        title:"改善点:"
    },
    eng: {
        5: [
            "Internet",
            "Furniture",
            "TV",                               
            "Bathroom",                                               
            "Mattress",              
            "Air conditioner",
            "Other",
        ],
        6: [
            "Room",
            "Bathroom",
            "Smell",                   
            "Linen",
            "Other",

        ],
        8: [
            "Not use",                      
            "Temperature", 
            "Cleanliness",                          
            "Many customer",  
            "Other", 
        ],
        9: [
            "Not use",
            "Quality",
            "Attitude",  
            "Environment",
            "Other",
        ],
        title:"Improve point : "
    },
    vie: {
        "5": [
            "Internet",
            "Nội thất",
            "Tivi",
            "Phòng tắm",
            "Điều hòa",
            "Nệm",
            "Khác"
        ],
        "6": [
            "Phòng",
            "Mùi",
            "Khác",
            "Phòng tắm",
            "Chăn ga gối"
        ],
        "8": [
            "Không sử dụng",
            "Độ sạch sẽ",
            "Nhiệt độ bồn tắm",
            "Khách quá đông",
            "Khác"
        ],
        "9": [
            "Không sử dụng",
            "Chất lượng massage",
            "Thái độ nhân viên",
            "Môi trường trong nhà",
            "Khác"
        ]
    },
    kor: {
        "5": [
            "인터넷",
            "가구",
            "TV",
            "욕실",
            "매트리스",
            "에어컨",
            "기타"
        ],
        "6": [
            "객실",
            "욕실",
            "냄새",
            "침구",
            "기타"
        ],
        "8": [
            "사용 안 함",
            "온도",
            "청결",
            "고객이 많음",
            "기타"
        ],
        "9": [
            "사용 안 함",
            "품질",
            "태도",
            "환경",
            "기타"
        ],
        "title": "개선할 점:"
    },
    chn: {
        "5": [
            "网络",
            "家具",
            "电视",
            "浴室",
            "空调",
            "床垫",
            "其他"
        ],
        "6": [
            "房间",
            "浴室",
            "气味",
            "床单",
            "其他"
        ],
        "8": [
            "未使用",
            "温度",
            "清洁",
            "客户众多",
            "其他"
        ],
        "9": [
            "未使用",
            "质量",
            "态度",
            "环境",
            "其他"
        ],
        "title": "改进点:"
    }
}

export const QUESTION5_TITLE_COL = {
    jap: [
        "①客室料金",
        "②受付の接客",
        "③受付以外の接客",
        "④朝食の味",
        "⑤朝食の提供速度",
        "⑥客室の設備", //
        "⑦客室の清潔感", //
        "⑧客室以外の清潔感", //⑧お部屋以外の清潔感
        "⑨露天風呂",
        "⑩マッサージ", //フットマッサージ
    ],
    eng: [
        "1 Price",
        "2 Reception's Attitude",
        "3 Other Attitude",
        "4 Breakfast Taste",
        "5 Breakfast Speed",
        "6 Room Equipment",
        "7 Room Cleanliness",
        "8 Others Cleanliness", 
        "9 Open Hot Bath",
        "10 Massage",
    ],
    vie: [
        "① Giá phòng",
        "② Thái độ phục vụ tại quầy lễ tân",
        "③ Thái độ phục vụ ngoài quầy lễ tân",
        "④ Hương vị bữa sáng",
        "⑤ Tốc độ phục vụ bữa sáng",
        "⑥ Trang thiết bị trong phòng",
        "⑦ Độ sạch sẽ của phòng",
        "⑧ Độ sạch sẽ khu vực ngoài phòng",
        "⑨ Bồn tắm lộ thiên",
        "⑩ Dịch vụ massage (massage chân)"
    ],
    "kor": [
        "1 가격",
        "2 프런트 직원 태도",
        "3 기타 직원 태도",
        "4 아침 식사 맛",
        "5 아침 식사 제공 속도",
        "6 객실 시설",
        "7 객실 청결도",
        "8 기타 청결도",
        "9 노천탕",
        "10 마사지"
    ],
    "chn": [
        "1 价格",
        "2 前台态度",
        "3 其他员工态度",
        "4 早餐味道",
        "5 早餐供应速度",
        "6 房间设施",
        "7 房间清洁度",
        "8 其他区域清洁度",
        "9 露天温泉",
        "10 按摩服务"
    ]
}

export const QUESTION5_TITLE_ROW = {
    jap: [
        "とても<br/>悪い", //とても悪い
        "悪い",
        "普通",
        "良い",
        "とても<br />良い", //とても良い
    ],
    eng: [
        "Very bad", 
        "Bad",
        "Normal",
        "Good",
        "Very good",
    ],
    vie: [
        "Rất kém",
        "Kém",
        "Bình thường",
        "Tốt",
        "Rất tốt"
    ],
    kor: [
        "매우 나쁨",
        "나쁨",
        "보통",
        "좋음",
        "매우 좋음"
    ],
    chn: [
        "非常差",
        "差",
        "一般",
        "好",
        "非常好"
    ]
}

export const COMPLETE = {
    jap: "アンケートに協力いただき、ありがとうございます。",
    eng: "Thank you for Survey.",
    vie: "Cảm ơn bạn đã hợp tác trả lời khảo sát.",
    kor: "설문에 참여해 주셔서 감사합니다.",
    chn: "感谢您参与本次调查。"
}